var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('page-title', {
    attrs: {
      "title": "Batches",
      "icon": "pe-7s-box2"
    }
  }), !_vm.isLoading ? _c('div', [_c('b-row', {
    staticClass: "mb-4"
  }, [_c('b-col', {
    staticClass: "d-flex d-flex col-lg-12 justify-content-end",
    attrs: {
      "lg": "12"
    }
  }, [_vm.hasPermission('orders.batch.create') ? _c('b-button', {
    staticClass: "bg-midnight-bloom text-white",
    attrs: {
      "to": _vm.shipmentBatchCreateRouterParams
    }
  }, [_vm._v("Nieuwe batch")]) : _vm._e()], 1)], 1), _c('b-row', {
    staticClass: "mb-4"
  }, [_c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('b-card', [_c('b-card-title', [_vm._v(" FILTERS ")]), _c('b-form', [_c('b-row', [_c('b-col', [_c('label', [_vm._v(_vm._s(_vm.$t(_vm.orderListColumnTitles.dispatcher_type)))]), _c('br'), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filterForm.dispatcher_type,
      expression: "filterForm.dispatcher_type"
    }],
    staticClass: "form-control form-control-sm",
    class: {
      isFilled: _vm.filterForm.dispatcher_type !== ''
    },
    attrs: {
      "disabled": !_vm.isFieldEditable('dispatcher_type')
    },
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.filterForm, "dispatcher_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }, _vm.filterDispatcherTypeChanged]
    }
  }, _vm._l(_vm.relevantDispatcherTypes, function (display_name, identifier) {
    return _c('option', {
      key: identifier,
      domProps: {
        "value": identifier
      }
    }, [_vm._v(_vm._s(display_name))]);
  }), 0)]), _c('b-col', [_c('label', [_vm._v(_vm._s(_vm.$t(_vm.orderListColumnTitles.dispatcher_identifier)))]), _c('br'), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filterForm.dispatcher_identifier,
      expression: "filterForm.dispatcher_identifier"
    }],
    staticClass: "form-control form-control-sm",
    class: {
      isFilled: _vm.filterForm.dispatcher_identifier !== ''
    },
    attrs: {
      "disabled": !_vm.isFieldEditable('dispatcher_identifier')
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.filterForm, "dispatcher_identifier", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, _vm._l(_vm.dispatchers, function (dispatcher, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": dispatcher.identifier
      }
    }, [_vm._v(_vm._s(dispatcher.display_name))]);
  }), 0)]), _c('b-col', [_c('label', [_vm._v(_vm._s(_vm.$t(_vm.orderListColumnTitles.dispatch_request_batch_type)))]), _c('br'), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filterForm.batch_type,
      expression: "filterForm.batch_type"
    }],
    staticClass: "form-control form-control-sm",
    class: {
      isFilled: _vm.filterForm.batch_type !== ''
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.filterForm, "batch_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._l(_vm.batchTypesSorted, function (batchType, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": batchType.identifier
      }
    }, [_vm._v(_vm._s(batchType.display_name))]);
  })], 2)]), _c('b-col', [_c('label', [_vm._v(_vm._s(_vm.$t(_vm.orderListColumnTitles.dispatch_request_batch_status)))]), _c('br'), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filterForm.status,
      expression: "filterForm.status"
    }],
    staticClass: "form-control form-control-sm",
    class: {
      isFilled: _vm.filterForm.status !== ''
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.filterForm, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._l(_vm.dispatchRequestBatchStatuses, function (display_name, identifier) {
    return _c('option', {
      key: identifier,
      domProps: {
        "value": identifier
      }
    }, [_vm._v(_vm._s(display_name))]);
  })], 2)])], 1)], 1)], 1)], 1)], 1), _c('b-card', [_c('b-card-title', [_vm._v("RESULTATEN")]), _vm.isSearching ? [_c('div', {
    staticClass: "loading"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v(" Gegevens ophalen… ")]), _c('span', {
    staticClass: "icon"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1)])] : _vm.batches.length === 0 ? [_c('b-alert', {
    attrs: {
      "show": "",
      "variant": "light"
    }
  }, [_vm._v(" Geen batches gevonden. ")])] : [_c('div', {
    staticClass: "d-none d-md-block"
  }, [_c('b-table', {
    attrs: {
      "items": _vm.batches,
      "fields": _vm.fields.default
    },
    scopedSlots: _vm._u([{
      key: "cell(created_at)",
      fn: function (row) {
        return [_vm._v(" " + _vm._s(_vm._f("datetimeshort")(row.value)) + " ")];
      }
    }, {
      key: "cell(dispatcher)",
      fn: function (row) {
        return [_c('location-link', {
          attrs: {
            "location": row.value
          }
        })];
      }
    }, {
      key: "cell(type)",
      fn: function (row) {
        return [_vm._v(" " + _vm._s(row.value.display_name) + " ")];
      }
    }, {
      key: "cell(identifier)",
      fn: function (row) {
        return [_c('router-link', {
          attrs: {
            "to": _vm.getBatchRoute(row.item)
          }
        }, [_vm._v(" " + _vm._s(row.value) + " ")])];
      }
    }, {
      key: "cell(dispatch_request_count)",
      fn: function (row) {
        return [_vm._v(" " + _vm._s(row.value) + " ")];
      }
    }, {
      key: "cell(status)",
      fn: function (row) {
        return [_vm._v(" " + _vm._s(_vm._f("dispatchRequestBatchStatus")(row.value)) + " ")];
      }
    }, {
      key: "cell(storage_zone)",
      fn: function (row) {
        return [_vm._v(" " + _vm._s(row.value ? row.value.display_name : '') + " ")];
      }
    }], null, false, 1954857226)
  })], 1), _c('div', {
    staticClass: "d-md-none"
  }, [_c('b-table', {
    attrs: {
      "items": _vm.batches,
      "fields": _vm.fields.mobile,
      "stacked": ""
    },
    scopedSlots: _vm._u([{
      key: "cell(identifier)",
      fn: function (row) {
        return [_c('router-link', {
          attrs: {
            "to": _vm.getBatchRoute(row.item)
          }
        }, [_vm._v(" " + _vm._s(row.value) + " ")])];
      }
    }, {
      key: "cell(status)",
      fn: function (row) {
        return [_vm._v(" " + _vm._s(_vm._f("dispatchRequestBatchStatus")(row.value)) + " ")];
      }
    }], null, false, 537444267)
  })], 1)]], 2)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }